import { renderSlot as _renderSlot, withModifiers as _withModifiers, withKeys as _withKeys, vModelText as _vModelText, resolveDirective as _resolveDirective, createElementVNode as _createElementVNode, withDirectives as _withDirectives, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _directive_autogrow = _resolveDirective("autogrow")!

  return (_openBlock(), _createElementBlock("label", null, [
    _renderSlot(_ctx.$slots, "default", {}, undefined, true),
    _withDirectives(_createElementVNode("textarea", {
      class: "cw-textarea",
      onKeydown: [
        _cache[0] || (_cache[0] = _withKeys(_withModifiers(
//@ts-ignore
(...args) => (this.hitEnter && this.hitEnter(...args)), ["exact","prevent"]), ["enter"])),
        _cache[1] || (_cache[1] = _withKeys(_withModifiers(($event: any) => (this.model += '\n'), ["shift","exact","prevent"]), ["enter"]))
      ],
      "onUpdate:modelValue": _cache[2] || (_cache[2] = ($event: any) => ((this.model) = $event)),
      rows: "1",
      enterkeyhint: "send"
    }, null, 544), [
      [_vModelText, this.model],
      [_directive_autogrow]
    ])
  ]))
}